//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return {
      serverList:Array,
      bubbleIndex:Number,
      pager: {
        page: '1',
        count: '1',
      },
      page: '1',
      count: '10'
    }
  },
  mounted() {
    this.getHost()
  },
  methods:{
    getHost(){
      let data = 'cmd=get_Promotion_list'
      this.$http.post('https://api.abeiyun.com/www/haomiao.php', data).then(({data}) => {
        if(data) {
          this.serverList = data.map((item)=>{
            return{
              id:item.vps_try_id,
              cpu:item.cpu,
              ram:item.ram,
              NET_WIDTH:item.NET_WIDTH,
              p_time:item.p_time,
              price:item.price,
            }
          })
          this.serverList[0].title = '入门型（BGP多线)'
          this.serverList[1].title = '进阶型（BGP多线)'
          this.serverList[2].title = '通用型（BGP多线)'
          this.serverList[3].title = '理想型（BGP多线)'
          this.serverList[4].title = '入门型（BGP多线)'
          this.serverList[5].title = '进阶型（BGP多线)'
          this.serverList[6].title = '通用型（BGP多线)'
          this.serverList[7].title = '理想型（BGP多线)'

          this.serverList[0].explain = '适用于个人网站初始阶段并发访问量小，经济配置省钱适用，两步购买方便快捷'
          this.serverList[1].explain = '适合流量适中的网站应用，或简单开发环境、代码存储库等'
          this.serverList[2].explain = '计算能力满足90%云计算使用者需求，适合企业运营活动、并行计算应用'
          this.serverList[3].explain = '适合对计算性能要求较高的应用场景，如企业运营活动、批量处理、分布式分析、游戏app等'
          this.serverList[4].explain = '适用于个人网站初始阶段并发访问量小，经济配置省钱适用，两步购买方便快捷'
          this.serverList[5].explain = '适合流量适中的网站应用，或简单开发环境、代码存储库等'
          this.serverList[6].explain = '计算能力满足90%云计算使用者需求，适合企业运营活动、并行计算应用'
          this.serverList[7].explain = '适合对计算性能要求较高的应用场景，如企业运营活动、批量处理、分布式分析、游戏app等'
        }
      })
    },
    buy(id) {
      /*if(state != '0'){
        this.$router.push('/user/hostmanage/'+ id)
      }else{
        let _this = this
        this.$vux.confirm.show({
          title: '确认',
          content: '您确定初始化吗?',
          onConfirm () {

          }
        })
      }*/


      let data = 'cmd=vps_try'+
        '&vps_try_id=' + id
      this.$vux.loading.show({
        text: 'Loading'
      })
      this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
        if(data.response==200){
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {

            }
          })
        }else if(data.response==50140){
          this.$vux.loading.hide()
          let _this = this
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/login')
            }
          })
        }else{
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/user/act.vue